(function () {
  'use strict';

  if (window.__kkNativeCoreReady) return;
  window.__kkNativeCoreReady = true;

  var desktopQuery = window.matchMedia('(min-width: 1024px)');
  var smallQuery = window.matchMedia('(max-width: 719px)');
  var dimmerOwners = new Set();
  var dimmer = document.querySelector('[data-site-main-dimmer]');

  function onMediaChange(media, handler) {
    if (media.addEventListener) {
      media.addEventListener('change', handler);
    } else if (media.addListener) {
      media.addListener(handler);
    }
  }

  function afterMotion(element, fallback, callback) {
    var finished = false;
    var timer;

    function finish() {
      if (finished) return;
      finished = true;
      window.clearTimeout(timer);
      element.removeEventListener('animationend', finish);
      element.removeEventListener('transitionend', finish);
      callback();
    }

    element.addEventListener('animationend', finish);
    element.addEventListener('transitionend', finish);
    timer = window.setTimeout(finish, fallback);
  }

  function setDimmer(owner, active) {
    if (!dimmer || !owner || document.body.hasAttribute('data-reduce-animations')) return;

    if (active) {
      if (dimmerOwners.has(owner)) return;
      dimmerOwners.add(owner);
      dimmer.setAttribute('data-animation', 'closed=>open');
      window.requestAnimationFrame(function () {
        dimmer.setAttribute('data-animation-state', 'open');
      });
      return;
    }

    dimmerOwners.delete(owner);
    if (dimmerOwners.size) return;

    dimmer.setAttribute('data-animation', 'open=>closed');
    dimmer.removeAttribute('data-animation-state');
    window.setTimeout(function () {
      if (!dimmerOwners.size) dimmer.removeAttribute('data-animation');
    }, 240);
  }

  function updateCartCount(itemCount) {
    var count = Number(itemCount) || 0;

    document.querySelectorAll('[data-header-cart-count]').forEach(function (element) {
      element.setAttribute('data-header-cart-count', count > 0 ? String(count) : '');
      element.classList.toggle('visible', count > 0);

      var button = element.closest('.site-header-cart-button');
      if (button) button.classList.toggle('count-hidden', count === 0);
    });
  }

  function parseSectionSettings(section) {
    var data = section && section.querySelector('[data-section-data]');
    if (!data) return {};

    try {
      return (JSON.parse(data.getAttribute('data-section-data') || data.textContent).settings) || {};
    } catch (error) {
      console.warn('KiekkoKingi native core: invalid header settings.', error);
      return {};
    }
  }

  function hydrateMobileNavigation(header) {
    if (!header) return false;

    var templates = header.querySelectorAll('[data-mobile-nav-template]');
    if (!templates.length) return header.hasAttribute('data-mobile-nav-hydrated');

    templates.forEach(function (template) {
      if (!template.content || !template.parentNode) return;
      template.parentNode.insertBefore(template.content.cloneNode(true), template);
      template.remove();
    });

    header.setAttribute('data-mobile-nav-hydrated', 'true');
    document.dispatchEvent(new CustomEvent('kk:mobile-nav-hydrated', { detail: { header: header } }));
    return true;
  }

  function setupMobileNavigation(section, header) {
    var menuToggle = header.querySelector('[data-menu-toggle]');
    var mobileNav;
    var panel;
    var overlay;
    var closeButton;
    var open = false;
    var lastFocusedInNavigation = null;

    /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
    function syncMobileNavigationWidgetLayering(forceClosed) {
      var keepsWidgetsHidden = Boolean(
        !forceClosed &&
        !desktopQuery.matches &&
        mobileNav &&
        mobileNav.isConnected &&
        (
          mobileNav.classList.contains('visible') ||
          mobileNav.classList.contains('animating-in') ||
          mobileNav.classList.contains('animating-out')
        )
      );

      if (document.body) {
        document.body.classList.toggle('kk-mobile-nav-open', keepsWidgetsHidden);
      }
    }
    /* KK_MOBILE_NAV_WIDGET_LAYERING_END */

    if (!menuToggle) return;

    function syncMenuToggle(expanded) {
      menuToggle.setAttribute('aria-controls', (mobileNav && mobileNav.id) || 'site-mobile-nav');
      menuToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    syncMenuToggle(false);

    function cacheNavigation() {
      hydrateMobileNavigation(header);
      mobileNav = header.querySelector('[data-mobile-nav]');
      panel = header.querySelector('[data-mobile-nav-panel]');
      overlay = header.querySelector('[data-mobile-nav-overlay]');
      closeButton = header.querySelector('[data-mobile-nav-close]');
      if (mobileNav && !mobileNav.id) mobileNav.id = 'site-mobile-nav';
      syncMenuToggle(open);
      return Boolean(mobileNav && panel);
    }

    function focusableElements() {
      if (!mobileNav) return [];
      return Array.from(mobileNav.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        var styles = window.getComputedStyle(element);

        return Boolean(
          element.isConnected &&
          element.tabIndex >= 0 &&
          !element.hidden &&
          !element.disabled &&
          element.getAttribute('aria-hidden') !== 'true' &&
          element.getAttribute('aria-disabled') !== 'true' &&
          !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
          styles.display !== 'none' &&
          styles.visibility !== 'hidden' &&
          (element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0)
        );
      });
    }

    function focusWithoutScroll(element) {
      if (!element || !element.isConnected || typeof element.focus !== 'function') return;

      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        element.focus();
      }
    }

    function preferredFocusTarget() {
      var focusable = focusableElements();

      if (lastFocusedInNavigation && focusable.indexOf(lastFocusedInNavigation) !== -1) {
        return lastFocusedInNavigation;
      }

      if (closeButton && focusable.indexOf(closeButton) !== -1) return closeButton;
      return focusable[0] || mobileNav;
    }

    function containFocus(event) {
      if (!open || !mobileNav) return;

      if (!mobileNav.isConnected) {
        open = false;
        document.removeEventListener('focusin', containFocus, true);
        return;
      }

      if (mobileNav.contains(event.target)) {
        lastFocusedInNavigation = event.target;
        return;
      }

      focusWithoutScroll(preferredFocusTarget());
    }

    function closeSubmenu(item) {
      var link = item.querySelector(':scope > .navmenu-link-parent');
      var button = item.querySelector(':scope > .navmenu-button');
      var submenu = item.querySelector(':scope > [data-navmenu-submenu]');
      if (!submenu) return;

      submenu.querySelectorAll('[data-navmenu-parent]').forEach(closeSubmenu);
      submenu.classList.remove('visible');
      window.setTimeout(function () {
        if (!submenu.classList.contains('visible')) submenu.style.display = '';
      }, 260);

      if (link) {
        link.classList.remove('navmenu-link-parent-active');
        link.setAttribute('aria-expanded', 'false');
      }
      if (button) button.setAttribute('aria-expanded', 'false');
    }

    function openSubmenu(item) {
      var link = item.querySelector(':scope > .navmenu-link-parent');
      var button = item.querySelector(':scope > .navmenu-button');
      var submenu = item.querySelector(':scope > [data-navmenu-submenu]');
      if (!submenu) return;

      submenu.style.display = 'flex';
      window.requestAnimationFrame(function () {
        submenu.classList.add('visible');
      });
      if (link) {
        link.classList.add('navmenu-link-parent-active');
        link.setAttribute('aria-expanded', 'true');
      }
      if (button) button.setAttribute('aria-expanded', 'true');
    }

    function handleSubmenuClick(event) {
      var button = event.target.closest('.navmenu-button');
      var link = event.target.closest('.navmenu-link-parent');
      var trigger = button || link;
      var item = trigger && trigger.closest('[data-navmenu-parent]');
      var submenu = item && item.querySelector(':scope > [data-navmenu-submenu]');
      if (!item || !submenu) return;

      var isOpen = submenu.classList.contains('visible');
      if (button || !isOpen) event.preventDefault();
      if (isOpen) closeSubmenu(item);
      else openSubmenu(item);
    }

    function trapFocus(event) {
      if (!open) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeNavigation();
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        focusWithoutScroll(mobileNav);
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var activeIndex = focusable.indexOf(document.activeElement);

      if (!mobileNav.contains(document.activeElement) || activeIndex === -1) {
        event.preventDefault();
        focusWithoutScroll(event.shiftKey ? last : first);
        return;
      }

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        focusWithoutScroll(last);
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        focusWithoutScroll(first);
      }
    }

    function openNavigation(event) {
      if (event) event.preventDefault();
      if (desktopQuery.matches || open || !cacheNavigation()) return;

      open = true;
      syncMenuToggle(true);
      mobileNav.setAttribute('aria-hidden', 'false');
      mobileNav.removeAttribute('inert');
      panel.style.height = window.innerHeight + 'px';
      document.body.classList.add('scroll-lock');
      mobileNav.classList.remove('animating-out');
      mobileNav.classList.add('animating', 'animating-in');
      /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
      syncMobileNavigationWidgetLayering(false);
      /* KK_MOBILE_NAV_WIDGET_LAYERING_END */

      afterMotion(mobileNav, 460, function () {
        if (!open) return;
        mobileNav.classList.remove('animating', 'animating-in');
        mobileNav.classList.add('visible');
      });

      mobileNav.addEventListener('click', handleSubmenuClick);
      document.addEventListener('keydown', trapFocus, true);
      document.addEventListener('focusin', containFocus, true);
      if (closeButton) closeButton.addEventListener('click', closeNavigation);
      if (overlay) {
        overlay.addEventListener('click', closeNavigation);
        overlay.addEventListener('touchmove', preventTouchMove, { passive: false });
      }

      lastFocusedInNavigation = closeButton || focusableElements()[0] || mobileNav;
      focusWithoutScroll(lastFocusedInNavigation);

      window.requestAnimationFrame(function () {
        if (open && !mobileNav.contains(document.activeElement)) {
          focusWithoutScroll(preferredFocusTarget());
        }
      });
    }

    function preventTouchMove(event) {
      event.preventDefault();
    }

    function closeNavigation(event, returnFocus) {
      if (event) event.preventDefault();
      if (!open || !mobileNav) return;

      open = false;
      syncMenuToggle(false);
      document.body.classList.remove('scroll-lock');
      mobileNav.classList.remove('animating-in', 'visible');
      mobileNav.classList.add('animating', 'animating-out');
      /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
      syncMobileNavigationWidgetLayering(false);
      /* KK_MOBILE_NAV_WIDGET_LAYERING_END */
      mobileNav.querySelectorAll('[data-navmenu-parent]').forEach(closeSubmenu);

      mobileNav.removeEventListener('click', handleSubmenuClick);
      document.removeEventListener('keydown', trapFocus, true);
      document.removeEventListener('focusin', containFocus, true);
      if (closeButton) closeButton.removeEventListener('click', closeNavigation);
      if (overlay) {
        overlay.removeEventListener('click', closeNavigation);
        overlay.removeEventListener('touchmove', preventTouchMove);
      }

      afterMotion(mobileNav, 340, function () {
        if (open) return;
        mobileNav.classList.remove('animating', 'animating-out');
        /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
        syncMobileNavigationWidgetLayering(false);
        /* KK_MOBILE_NAV_WIDGET_LAYERING_END */
      });

      lastFocusedInNavigation = null;
      if (returnFocus !== false && menuToggle.isConnected && typeof menuToggle.focus === 'function') menuToggle.focus();
      mobileNav.setAttribute('aria-hidden', 'true');
      mobileNav.setAttribute('inert', '');
    }

    menuToggle.addEventListener('click', function (event) {
      if (!desktopQuery.matches) openNavigation(event);
    });

    window.addEventListener('resize', function () {
      if (panel && open) panel.style.height = window.innerHeight + 'px';
    });

    onMediaChange(desktopQuery, function () {
      if (!desktopQuery.matches) return;

      closeNavigation(null, false);
      /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
      syncMobileNavigationWidgetLayering(true);
      /* KK_MOBILE_NAV_WIDGET_LAYERING_END */

      var active = document.activeElement;
      var focusWasLost = !active || active === document.body || active === document.documentElement;
      var focusStayedInNavigation = Boolean(mobileNav && active && mobileNav.contains(active));

      if (focusWasLost || focusStayedInNavigation) {
        var desktopTarget = header.querySelector('.site-logo[href], .site-logo a[href], .site-logo-link[href], .site-navigation a[href]');
        var targetIsAvailable = Boolean(
          desktopTarget &&
          desktopTarget.isConnected &&
          desktopTarget.getClientRects().length > 0 &&
          !desktopTarget.closest('[hidden], [inert], [aria-hidden="true"]')
        );

        if (targetIsAvailable) focusWithoutScroll(desktopTarget);
      }
    });

    section.__kkCloseMobileNavigation = closeNavigation;

    /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
    document.addEventListener('shopify:section:unload', function handleMobileNavigationSectionUnload(event) {
      var target = event.target;

      if (!target || (target !== section && (!target.contains || !target.contains(section)))) return;
      closeNavigation(null, false);
      syncMobileNavigationWidgetLayering(true);
      document.removeEventListener('shopify:section:unload', handleMobileNavigationSectionUnload);
    });
    window.addEventListener('pagehide', function () {
      syncMobileNavigationWidgetLayering(true);
    });
    window.addEventListener('pageshow', function () {
      if (!mobileNav || !mobileNav.isConnected) return;
      syncMobileNavigationWidgetLayering(false);
    });
    /* KK_MOBILE_NAV_WIDGET_LAYERING_END */
  }

  function setupDesktopNavigation(header) {
    var navigation = header.querySelector('[data-site-navigation]');
    if (!navigation) return;

    var parents = Array.from(navigation.querySelectorAll('[data-navmenu-parent]'));

    function siblings(item) {
      return Array.from(item.parentElement ? item.parentElement.children : []).filter(function (candidate) {
        return candidate !== item && candidate.matches('[data-navmenu-parent]');
      });
    }

    function closeItem(item, immediate) {
      var link = item.querySelector(':scope > .navmenu-link-parent');
      var submenu = item.querySelector(':scope > [data-navmenu-submenu]');
      if (!submenu || !item.classList.contains('open')) return;

      item.__kkMenuOpen = false;
      window.clearTimeout(item.__kkCloseTimer);
      submenu.classList.remove('animating-in');

      function finish() {
        item.classList.remove('open', 'alternate-drop');
        submenu.classList.remove('animating-out');
        if (link) link.setAttribute('aria-expanded', 'false');
      }

      if (immediate) {
        finish();
      } else {
        submenu.classList.add('animating-out');
        afterMotion(submenu, 260, finish);
      }
    }

    function openItem(item) {
      if (!desktopQuery.matches) return;
      var link = item.querySelector(':scope > .navmenu-link-parent');
      var submenu = item.querySelector(':scope > [data-navmenu-submenu]');
      if (!submenu) return;

      siblings(item).forEach(function (sibling) { closeItem(sibling, true); });
      window.clearTimeout(item.__kkCloseTimer);
      item.__kkMenuOpen = true;

      if (!item.classList.contains('open')) {
        item.classList.add('open');
        submenu.classList.remove('animating-out');
        submenu.classList.add('animating-in');
        afterMotion(submenu, 260, function () { submenu.classList.remove('animating-in'); });
      }

      if (link) link.setAttribute('aria-expanded', 'true');

      if (submenu.classList.contains('navmenu-meganav')) {
        submenu.style.left = '';
        var megaBounds = submenu.getBoundingClientRect();
        if (megaBounds.left > 0) submenu.style.left = '-' + megaBounds.left + 'px';
      } else {
        item.classList.toggle('alternate-drop', submenu.getBoundingClientRect().right > document.documentElement.clientWidth);
      }
    }

    parents.forEach(function (item) {
      var link = item.querySelector(':scope > .navmenu-link-parent');
      var submenu = item.querySelector(':scope > [data-navmenu-submenu]');
      if (!link || !submenu) return;

      item.addEventListener('mouseenter', function () { openItem(item); });
      item.addEventListener('mouseleave', function () {
        window.clearTimeout(item.__kkCloseTimer);
        item.__kkCloseTimer = window.setTimeout(function () { closeItem(item, false); }, 400);
      });
      item.addEventListener('click', function (event) {
        if (!desktopQuery.matches) return;
        event.stopPropagation();
        var parentLink = event.target.closest('.navmenu-link-parent');
        if (parentLink && parentLink === link && !item.__kkMenuOpen) {
          event.preventDefault();
          openItem(item);
        }
      });
      item.addEventListener('focusin', function (event) {
        if (event.target === link) siblings(item).forEach(function (sibling) { closeItem(sibling, true); });
      });
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        closeItem(item, true);
        link.focus();
      });
    });

    document.body.addEventListener('click', function () {
      if (desktopQuery.matches) parents.forEach(function (item) { closeItem(item, false); });
    });
    document.body.addEventListener('focusin', function (event) {
      if (desktopQuery.matches && !navigation.contains(event.target)) {
        parents.forEach(function (item) { closeItem(item, false); });
      }
    });

    navigation.querySelectorAll('[data-meganav-menu] .navmenu-meganav-items').forEach(function (list) {
      function updateOverflow() {
        var container = list.closest('[data-meganav-menu]');
        if (!container) return;
        container.classList.toggle('meganav--overflows-left', list.scrollLeft > 0);
        container.classList.toggle('meganav--overflows-right', list.scrollLeft < list.scrollWidth - list.clientWidth - 1);
      }
      list.addEventListener('scroll', updateOverflow, { passive: true });
      updateOverflow();
    });
  }

  function setupTraditionalHeader(section, header, settings) {
    var menuToggle = header.querySelector('[data-menu-toggle]');
    var navigation = header.querySelector('[data-site-navigation]');
    var target = document.querySelector('.intersection-target');
    var transitioning = false;
    var lastToggle = 0;

    if (!menuToggle || !navigation) return;

    function closeNavigation(immediate) {
      if (transitioning && !immediate) return;
      menuToggle.classList.remove('active');

      function finish() {
        header.classList.remove('site-header-nav--open');
        navigation.style.marginTop = '';
        transitioning = false;
      }

      if (immediate || !header.classList.contains('site-header-nav--open')) {
        finish();
        return;
      }

      transitioning = true;
      navigation.style.marginTop = '-' + navigation.getBoundingClientRect().height + 'px';
      afterMotion(navigation, 260, finish);
    }

    function openNavigation() {
      if (transitioning || header.classList.contains('site-header-nav--open')) return;
      transitioning = true;
      menuToggle.classList.add('active');
      header.classList.add('site-header-nav--open');
      navigation.style.marginTop = '-' + navigation.getBoundingClientRect().height + 'px';
      window.requestAnimationFrame(function () {
        navigation.style.marginTop = '0px';
      });
      afterMotion(navigation, 260, function () {
        transitioning = false;
        navigation.style.marginTop = '';
      });
    }

    menuToggle.addEventListener('click', function (event) {
      if (!desktopQuery.matches) return;
      event.preventDefault();
      if (header.classList.contains('site-header-nav--open')) closeNavigation(false);
      else openNavigation();
    });

    if (settings.sticky_header && target && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!desktopQuery.matches || document.body.classList.contains('scroll-lock')) return;
        if (Date.now() - lastToggle < 500) return;
        lastToggle = Date.now();

        if (entries[0].isIntersecting) {
          header.classList.remove('traditional-header--scrolled');
          openNavigation();
          menuToggle.classList.remove('active');
        } else {
          closeNavigation(false);
          header.classList.add('traditional-header--scrolled');
        }
      });
      observer.observe(target);
    }

    onMediaChange(desktopQuery, function () {
      if (desktopQuery.matches && !header.classList.contains('traditional-header--scrolled')) openNavigation();
      if (!desktopQuery.matches) {
        transitioning = false;
        navigation.style.marginTop = '';
      }
    });
  }

  function setupBasicHeader(header, settings) {
    var content = header.querySelector('[data-site-header-main]');
    var logo = header.querySelector('.site-logo');
    var logoImage = logo && logo.querySelector('img');
    var logoText = logo && logo.querySelector('.desktop-logo-text');
    var navList = header.querySelector('.site-navigation > [data-navmenu]');
    var actions = header.querySelector('.site-header-main-actions');
    var searchWrapper = header.querySelector('[data-search-wrapper]');
    var searchButton = header.querySelector('[data-search-toggle]');
    var searchInput = header.querySelector('[data-live-search-input]');
    var searchClose = header.querySelector('[data-search-close]');
    var takeoverCancel = header.querySelector('[data-live-search-takeover-cancel]');
    var resizeFrame;

    function adjustLayout() {
      if (!content || !logo || !navList || !actions) {
        header.classList.remove('site-header-loading');
        return;
      }

      var styles = window.getComputedStyle(content);
      var headerWidth = content.clientWidth - parseFloat(styles.paddingLeft || 0);
      var actionWidth = actions.clientWidth;
      var logoWidth = logo.clientWidth;
      var logoHeight = logo.clientHeight;
      var navWidth = navList.clientWidth;

      if (!desktopQuery.matches) {
        content.style.minHeight = '';
      } else if (settings.navigation_layout === 'below' || settings.desktop_logo_position !== 'center') {
        content.style.minHeight = logoHeight + parseFloat(styles.paddingTop || 0) + parseFloat(styles.paddingBottom || 0) + 'px';
      }

      if (settings.navigation_layout !== 'below') {
        if (settings.desktop_logo_position === 'center') {
          var logoContentWidth = logoImage ? logoImage.clientWidth : (logoText ? logoText.clientWidth : logoWidth);
          header.classList.toggle('site-header-stacked', navWidth > logoWidth / 2 - logoContentWidth / 2);
        } else {
          header.classList.toggle('site-header-stacked', headerWidth / 2 <= navWidth / 2 + Math.max(actionWidth, logoWidth));
        }
      }

      header.classList.remove('site-header-loading');
    }

    function closeSearch() {
      if (!content) return;
      content.classList.add('live-search--hidden');
      setDimmer(header, false);
      if (searchWrapper && searchWrapper.contains(document.activeElement) && searchButton) searchButton.focus();
    }

    function openSearch(event) {
      if (event) event.stopPropagation();
      if (!content) return;
      content.classList.remove('live-search--hidden');
      setDimmer(header, true);
      if (searchInput) searchInput.focus();
    }

    if (searchButton) searchButton.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (takeoverCancel) takeoverCancel.addEventListener('click', closeSearch);
    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSearch();
    });
    window.addEventListener('focusin', function () {
      if (searchWrapper && !searchWrapper.contains(document.activeElement) && !content.classList.contains('live-search--hidden')) closeSearch();
    });
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(adjustLayout);
    }, { passive: true });
    if (logoImage) logoImage.addEventListener('load', adjustLayout);
    adjustLayout();
  }

  function setupMinimalHeader(header) {
    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchBar = header.querySelector('[data-live-search]');
    var searchInput = header.querySelector('[data-live-search-input]');
    var menuToggle = header.querySelector('[data-menu-toggle]');
    var navigation = header.querySelector('[data-site-navigation]');
    var searchClass = 'site-header-search--open';

    function closeSearch() {
      if (!header.classList.contains(searchClass)) return;
      header.classList.remove(searchClass);
      setDimmer(header, false);
    }

    function toggleSearch(event) {
      event.preventDefault();
      event.stopPropagation();
      if (header.classList.contains(searchClass)) {
        closeSearch();
        return;
      }

      header.classList.add(searchClass);
      setDimmer(header, true);
      if (searchInput) searchInput.focus();
    }

    function toggleDesktopMenu(event) {
      if (!desktopQuery.matches || !navigation) return;
      event.preventDefault();
      var isOpen = header.classList.toggle('site-header-nav--open');
      menuToggle.classList.toggle('active', isOpen);
      navigation.style.marginTop = isOpen ? '0px' : '-' + navigation.getBoundingClientRect().height + 'px';
    }

    if (searchToggle) searchToggle.addEventListener('click', toggleSearch);
    if (searchBar) searchBar.addEventListener('click', function (event) { event.stopPropagation(); });
    if (menuToggle) menuToggle.addEventListener('click', toggleDesktopMenu);
    window.addEventListener('click', closeSearch);
    window.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeSearch();
      if (searchToggle) searchToggle.focus();
    });
    onMediaChange(smallQuery, closeSearch);

    if (navigation) navigation.style.marginTop = '-' + navigation.getBoundingClientRect().height + 'px';
  }

  function setupHeader() {
    var data = document.querySelector('[data-section-type="static-header"]');
    if (!data) return;

    var section = data.parentElement;
    var header = section && section.querySelector('[data-site-header]');
    if (!section || !header) return;

    var settings = parseSectionSettings(section);
    document.body.style.setProperty('--scrollbar-width', window.innerWidth - document.documentElement.clientWidth + 'px');
    if (settings.sticky_header) section.classList.add('site-header--sticky');

    setupMobileNavigation(section, header);
    setupDesktopNavigation(header);

    if (settings.header_layout === 'basic') setupBasicHeader(header, settings);
    else if (settings.header_layout === 'minimal') setupMinimalHeader(header, settings);
    else setupTraditionalHeader(section, header, settings);
  }

  function setupUtilityBar() {
    var data = document.querySelector('[data-section-type="static-utility-bar"]');
    var section = data && data.parentElement;
    var mobile = section && section.querySelector('[data-utility-bar-mobile]');
    if (!mobile) return;

    var settings = parseSectionSettings(section);

    function cloneItems() {
      var target = document.querySelector('[data-mobile-nav-content]');
      if (!target || target.querySelector('[data-kk-utility-clone]')) return;

      var fragment = document.createDocumentFragment();
      Array.from(mobile.children).forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('data-kk-utility-clone', '');
        fragment.appendChild(clone);
      });

      if (settings.mobile_layout === 'below') target.appendChild(fragment);
      else target.insertBefore(fragment, target.firstElementChild);
    }

    cloneItems();
    document.addEventListener('kk:mobile-nav-hydrated', cloneItems);
  }

  function setupDisclosures(root) {
    root.querySelectorAll('[data-disclosure-country], [data-disclosure-locale]').forEach(function (disclosure) {
      var list = disclosure.querySelector('[data-disclosure-list]');
      var toggle = disclosure.querySelector('[data-disclosure-toggle]');
      var input = disclosure.querySelector('[data-disclosure-input]');
      if (!list || !toggle || !input) return;

      function hide() {
        list.classList.remove('disclosure-list--visible', 'disclosure-list--alternate-drop');
        toggle.setAttribute('aria-expanded', 'false');
      }

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var opening = !list.classList.contains('disclosure-list--visible');
        hide();
        if (!opening) return;

        list.classList.add('disclosure-list--visible');
        toggle.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () {
          var bounds = list.getBoundingClientRect();
          list.classList.toggle('disclosure-list--alternate-drop', bounds.left + bounds.width + 30 > window.innerWidth);
        });
      });

      disclosure.querySelectorAll('[data-disclosure-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          input.value = option.dataset.value;
          var form = disclosure.closest('form');
          if (form) form.submit();
        });
      });

      disclosure.addEventListener('focusout', function (event) {
        if (!disclosure.contains(event.relatedTarget)) hide();
      });
      disclosure.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        hide();
        toggle.focus();
      });
      document.addEventListener('click', function (event) {
        if (!disclosure.contains(event.target)) hide();
      });
    });
  }

  function setupFooter() {
    var data = document.querySelector('[data-section-type="static-footer"]');
    var footer = (data && data.parentElement) || document.querySelector('.kk-footer, [data-site-footer]');
    if (!footer) return;

    function applyLayout() {
      footer.querySelectorAll('.has-accordion').forEach(function (block) {
        if (desktopQuery.matches) block.classList.add('accordion--active');
        else block.classList.remove('accordion--active');
      });
    }

    footer.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger || !footer.contains(trigger) || desktopQuery.matches) return;
      event.preventDefault();
      var block = trigger.closest('.has-accordion');
      if (block) block.classList.toggle('accordion--active');
    });

    setupDisclosures(footer);
    applyLayout();
    onMediaChange(desktopQuery, applyLayout);
  }

  function setupFormFields() {
    function sync(input) {
      if (!input || !input.matches('.form-field-input')) return;
      input.classList.toggle('form-field-filled', String(input.value || '').length > 0);
    }

    document.querySelectorAll('.form-field-input').forEach(sync);
    document.addEventListener('focusin', function (event) { sync(event.target); });
    document.addEventListener('focusout', function (event) { sync(event.target); });
    document.addEventListener('input', function (event) { sync(event.target); });
    document.addEventListener('change', function (event) { sync(event.target); });
  }

  window.KKNativeCore = {
    hydrateMobileNavigation: hydrateMobileNavigation,
    isDesktop: function () { return desktopQuery.matches; },
    isSmall: function () { return smallQuery.matches; },
    setDimmer: setDimmer,
    updateCartCount: updateCartCount
  };

  setupFormFields();
  setupHeader();
  setupUtilityBar();
  setupFooter();
  document.dispatchEvent(new CustomEvent('kk:native-core-ready'));
}());
